import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c97a1d12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-txt" }

import { Expand, Fold } from '@element-plus/icons-vue';
	import { ref, reactive } from 'vue';
	import { computed } from 'vue';
	import { useStore } from 'vuex';
	import { useRoute } from 'vue-router';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'LeftMenu',
  setup(__props) {

	let route = useRoute();

	//是否折叠
	let isCollapse = ref(false);
	//切换折叠效果
	const handleCollapse = () => {
		isCollapse.value = !isCollapse.value;
	};
	//store
	const store = useStore();
	let routerNavList = computed(() => store.state.menu.routerNavList);
	console.log('routerNavList',routerNavList)

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["menu-box", _unref(isCollapse) ? 'expand-active' : ''])
      }, [
        _createElementVNode("div", {
          class: "expand",
          onClick: handleCollapse
        }, [
          _createVNode(_component_el_icon, {
            class: _normalizeClass(_unref(isCollapse) ? 'rotate-img' : '')
          }, {
            default: _withCtx(() => [
              (_unref(isCollapse))
                ? (_openBlock(), _createBlock(_unref(Fold), { key: 0 }))
                : (_openBlock(), _createBlock(_unref(Expand), { key: 1 }))
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createVNode(_component_el_menu, {
          collapse: _unref(isCollapse),
          router: true,
          "default-openeds": ['1'],
          "default-active": _unref(route).path
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routerNavList), (item) => {
              return (_openBlock(), _createBlock(_component_el_sub_menu, {
                key: item.am_id,
                index: item.am_id + ''
              }, {
                title: _withCtx(() => [
                  _createElementVNode("i", {
                    class: _normalizeClass(item.am_icon),
                    style: {"font-size":"19px","color":"#1e9fff"}
                  }, null, 2),
                  _createElementVNode("span", _hoisted_1, _toDisplayString(item.am_name), 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.child, (childItem) => {
                    return (_openBlock(), _createBlock(_component_el_menu_item, {
                      index: childItem.am_path,
                      key: childItem.am_path
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(childItem.am_name), 1)
                      ]),
                      _: 2
                    }, 1032, ["index"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["index"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["collapse", "default-active"])
      ], 2)
    ]),
    _: 1
  }))
}
}

})